import React from 'react'
import { useOrderById } from '../hooks/useOrderById'
import { routesDef } from '../../../../config/routes'
import { PaymentStatusContainer } from './PaymentStatusContainer'

export default function Failed() {
  const { document, loading } = useOrderById()
  const orderName = `${document?.code ?? '--'} - ${document?.by?.company?.name ?? '--'}`
  const redirecTo = routesDef.OrderItemPage.altPath({ _id: document?._id })

  return (
    <PaymentStatusContainer
      orderName={orderName}
      redirecTo={redirecTo}
      loading={loading}
      message={'Payment Failed!'}
      subMessage={
        <div>
          The payment could not be processed at this time for order <b>{orderName}</b>. Please check Stripe dashboard
          for more information.
        </div>
      }
      icon="xmark"
      alertType="danger"
    />
  )
}
